import localforage from 'localforage';
import type { EnergyTypes, AggregationLevel } from '~/types/new/energy';

export const useExploreStorage = () => {
  // Store
  const { areaId, period, energyType, aggregationLevel } = storeToRefs(exploreStore());
  const { setAreaId, setPeriod, setEnergyType, setAggregationLevel } = exploreStore();
  const { selectedSite } = storeToRefs(globalStore());
  const { getAreas } = areaStore();
  const { availableArea, availableEnergyType } = coreAreaHelper();

  // Data
  const siteId = computed(() => selectedSite.value[0]);
  const clientId = computed(() => globalStore().getSelectedClient);

  // ==================== Forage ====================
  const getKeysFromForage = async () => {
    if (!siteId.value) return { areaForage: null, energyTypeForage: null, periodForage: null, aggregationLevelForage: null };
    const areaForage: number | null = await localforage.getItem<number>(`nrjx-${clientId.value}-${siteId.value}-explore-v2-area`);
    const energyTypeForage: EnergyTypes | null = await localforage.getItem<EnergyTypes>(
      `nrjx-${clientId.value}-${siteId.value}-explore-v2-energy-type`,
    );
    const periodForage: string | null = await localforage.getItem<string>(`nrjx-${clientId.value}-${siteId.value}-explore-v2-period`);
    const aggregationLevelForage: AggregationLevel | null = await localforage.getItem<AggregationLevel>(
      `nrjx-${clientId.value}-${siteId.value}-explore-v2-aggregation-level`,
    );
    const periodForageParsed = JSON.parse(periodForage ?? '{}');

    // SET
    if (areaForage) setAreaId(areaForage);
    if (energyTypeForage) setEnergyType(energyTypeForage);
    if (periodForageParsed?.start && periodForageParsed?.end) setPeriod({ start: periodForageParsed.start, end: periodForageParsed.end });
    if (aggregationLevelForage) setAggregationLevel(aggregationLevelForage);

    // CHECK
    areaId.value = availableArea(getAreas, areaId.value) ?? areaId.value;
    energyType.value = availableEnergyType(areaId.value, energyType.value) ?? energyType.value;
  };

  const setKeysInForage = async () => {
    await localforage.setItem<string>(`nrjx-${clientId.value}-${siteId.value}-explore-v2-period`, JSON.stringify(period.value));
    await localforage.setItem<number>(`nrjx-${clientId.value}-${siteId.value}-explore-v2-area`, areaId.value);
    await localforage.setItem<EnergyTypes>(`nrjx-${clientId.value}-${siteId.value}-explore-v2-energy-type`, energyType.value);
    await localforage.setItem<AggregationLevel>(
      `nrjx-${clientId.value}-${siteId.value}-explore-v2-aggregation-level`,
      aggregationLevel.value,
    );
  };

  return {
    getKeysFromForage,
    setKeysInForage,
  };
};
